/** The teams Productlane works with: the picker's teams narrowed to the synced ones. */
export function teamsForNewIssues(
	selectedTeamIds: readonly string[],
	syncTeamIds: readonly string[] | null | undefined,
): string[] {
	if (!syncTeamIds || syncTeamIds.length === 0) return [...selectedTeamIds]
	const both = selectedTeamIds.filter((id) => syncTeamIds.includes(id))
	return both.length > 0 ? both : [...syncTeamIds]
}
